import React, { useEffect, useState } from "react";
import { IoMdClose } from "react-icons/io";
import { getProjectData, getVisaAllocation } from "../../../../store/Api";
import { useDispatch, useSelector } from "react-redux";
import nodeinstance from "../../../../nodeInstance";
import { setAppError } from "../../../../store/userSlice";

export default function ProjectAllocation({
  showPromptElement,
  setPopUpopen,
  visaId,
  popUpdata,
  setApiTrigger,
}) {
  const dispatch = useDispatch();
  const token = localStorage.getItem("token");

  useEffect(() => {
    dispatch(getProjectData(token));
  }, []);
  const projectData = useSelector((state) => state.projectData);
  console.log("projectData.....projectData", popUpdata);
  const [visaCount, setVisaCount] = useState();
  const [projectId, setProjectId] = useState();
  const handleProjectHandle = (e) => {
    setProjectId(e.target.value);
  };
  const Nodetoken = localStorage.getItem("nodeToken");

  const allocated =
    popUpdata.allocated === null ? 0 : parseInt(popUpdata.allocated);
  const visaReturnRequestedQty =
    popUpdata.visa_return_requested_qty === null
      ? 0
      : parseInt(popUpdata.visa_return_requested_qty);
  const visaReturnApprovalQty =
    popUpdata.visa_return_approval_qty === null
      ? 0
      : parseInt(popUpdata.visa_return_approval_qty);

  const totalUsedVisas =
    allocated + visaReturnRequestedQty + visaReturnApprovalQty;
  const remainingVisas = parseInt(popUpdata.total_visa) - totalUsedVisas;

  const onSubmit = async () => {
    console.log("data to be seen here.......", visaCount, projectId);
    if (visaCount <= 0) {
      dispatch(
        setAppError({
          msg: "Total visas count must be greater than 0",
        })
      );
      return;
    }
    if (visaCount > remainingVisas) {
      dispatch(
        setAppError({
          msg: `You can able to assign upto ${remainingVisas} visas`,
        })
      );
      return;
    }
    const reqObject = {
      vrf_visa_id: visaId,
      project_id: projectId,
      total_allocated: visaCount,
    };
    console.log("reqObjectreqObject", reqObject);
    const response = await nodeinstance.post(
      "/dashboard/visa-stock/assign",
      reqObject,
      {
        headers: { Authorization: `Bearer ${Nodetoken}` },
      }
    );
    if (response.status === 200) {
      setPopUpopen(false);
      dispatch(
        setAppError({
          msg: "Visa assigned to project successfully.",
          color: "success",
        })
      );
      setApiTrigger(true);
      dispatch(getVisaAllocation(Nodetoken));
    }
  };
  const [checkData,setCheckData] = useState();

  // const Nodetoken = localStorage.getItem("nodeToken");
  const getRequiredData = async () => {
    try {
      const data = await nodeinstance.get(
        `/getNationalityfromenquiry/${projectId}`,
        {
          headers: { Authorization: `Bearer ${Nodetoken}` },
        }
      )
      if (data.status === 200){

      }
    } catch (error) {
      console.log("error to be seen in console", error);
    }
  };

  console.log("check the right page");
  return (
    <>
      <div
        className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center ${
          showPromptElement ? "flex" : "hidden"
        }`}
      >
        <div className="max-w-lg w-full h-auto   rounded-md bg-white/95 flex  flex-col p-4 relative">
          <div className="flex justify-between items-center w-full">
            <h1
              className="text-md font-semibold cursor-pointer"
              onClick={() => {
                setPopUpopen(false);
              }}
            >
              <IoMdClose />
            </h1>
          </div>
          <div className="w-full flex flex-col gap-3 my-3 p-5">
            <div className="flex flex-col w-full gap-1">
              <label htmlFor="" className="px-1">
                PROJECT
              </label>
              <select
                className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
                onChange={handleProjectHandle}
              >
                <option>SELECT VALUE</option>
                {projectData?.data?.map((data, index) => (
                  <React.Fragment key={index}>
                    <option value={data.id}>{data.name}</option>
                  </React.Fragment>
                ))}
              </select>
            </div>
            <div className="flex flex-col p-2 gap-1 w-full max-w-md">
              <label htmlFor={`addOrEdit-name`} className="text-xs ">
                TOTAL VISAS
              </label>
              <input
                type="number"
                className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
                onChange={(e) => {
                  setVisaCount(e.target.value);
                }}
              />
              <h6 className="text-sm">UNALLOCATED VISAS : {remainingVisas} </h6>
            </div>
            <div className="flex gap-3 w-full justify-center">
              <button
                className="w-full max-w-xs-ultra py-2 px-5 rounded-md ring-1 ring-red text-white bg-red"
                onClick={() => {
                  onSubmit();
                }}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
